module.exports = __webpack_public_path__ + "media/images/icons/location-b6772478827633b809f51e33c0e223f2.svg";